import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(2, 0, 7.51, 0),
  },
  description: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.labraText.primary,
  },
  content: {
    marginTop: theme.spacing(0),
  },
  horizontalDivider: {
    borderTop: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: theme.spacing(0.5),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  currency: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: theme.spacing(1.75),
    lineHeight: '20px',
    textAlign: 'center',
  },
  renewalIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  infoIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.125, 0, 0),
    marginLeft: theme.spacing(1),
  },
  renewalOffIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    verticalAlign: 'middle',
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  contractRed: {
    color: theme.palette.error.dark,
  },
  contractOrange: {
    color: '#CE8040',
  },
  serachWrapper: {
    background: theme.palette.common.white,
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(0.75),
  },
}))
